import { render, staticRenderFns } from "./NovoOrcamento.vue?vue&type=template&id=c3227aae&scoped=true&"
import script from "./NovoOrcamento.vue?vue&type=script&lang=js&"
export * from "./NovoOrcamento.vue?vue&type=script&lang=js&"
import style0 from "./NovoOrcamento.vue?vue&type=style&index=0&id=c3227aae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3227aae",
  null
  
)

export default component.exports